import type { ReactNode } from 'react';
import './web.css';

export default function WebShell({ children }: { children: ReactNode }) {
  return <div className="platform-web-shell">{children}</div>;
}
